const digest = '9df26058920fdd67f58dac772a5947d7f84d49937647427df73bee8548d7e26f';
const css = `._customIconSize_1v6ph_1>span>svg{height:3rem!important;width:3em!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'customIconSize': '_customIconSize_1v6ph_1' };
export const customIconSize = '_customIconSize_1v6ph_1';
export { css, digest };